// Action types
export const MESSAGE_BAR_DISMISS = 'MESSAGE_BAR_DISMISS';
export const MESSAGE_BAR_DISPLAY = 'MESSAGE_BAR_DISPLAY';
export const MESSAGE_BAR_FLAG = 'MESSAGE_BAR_FLAG';
export const RETRIEVE_MESSAGE = 'RETRIEVE_MESSAGE';
